module.exports = __webpack_public_path__ + "img/sld_aux_big_star_delta_v_trans.a412abe9.svg";